export namespace AppVersionModel {
    export interface AppVersion {
        id: number;
        createdAt: string;
        updatedAt: string;
        majorRelease: number;
        minorRelease: number;
        patchRelease: number;
        downloadAppLink: string;
    }
}
